import aiAgents from './ai-agents.json';
import aiAgent from './ai-agent/ai-agent.json';
import analytics from './analytics/analytics.json';
import auth from './auth.json';
import channels from './channels/channels.json';
import dialogs from './dialogs.json';
import common from './common.json';
import integrations from './integrations.json';
import billing from './billing.json';
import prompt from './ai-agent/prompt.json';
import knowledgeBase from './knowledge-base.json';
import messages from './messages.json';
import profile from './profile.json';
import sidebar from './sidebar/sidebar.json';
import team from './team.json';
import presets from './presets.json';
import preview from './preview.json';

export default {
  aiAgent,
  aiAgents,
  analytics,
  auth,
  channels,
  dialogs,
  common,
  billing,
  prompt,
  integrations,
  knowledgeBase,
  messages,
  profile,
  sidebar,
  team,
  presets,
  preview,
};
